import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import FulfillmentOrderReport from 'app/models/fulfillment_order_report';

export default ReportsBase.extend({
  model: FulfillmentOrderReport,
  url: appUrl('reports/fulfillment_order'),
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_order_reports.js